export default {
  text: 'Newsletter',
  thumbnail:
    'https://vastreach.com/static_assets/email/thumnails/Newsletter_email.jpg',
  snippets: {
    Button: {
      icon: 'RadioButton',
      text: 'Button',
      editor: 'button',
      html: '<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px;margin: 0 auto 0;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;"><p style="text-align: center;margin:0;"><a data-button-text="Start now" data-button-url="https://www.vastreach.com" data-button-color="#ffffff" data-button-background-color="#a09e00" href="#" target="_blank"><button style="color: #ffffff; background-color: #a09e00;border: 0; padding: 15px 25px; margin: 0; border-radius: 0; cursor: pointer;"><strong>Start Now</strong></button></a></p></div><!-- End of Dynamic WYSIWYG Content -->',
    },
    Social: {
      icon: 'Share',
      text: 'Social',
      editor: 'social-media',
      html: '<!-- Dynamic WYSIWYG Content --><table style="margin: 0 auto;background: transparent;" border="0" cellpadding="0" cellspacing="0" align="center"><tr><td width="600" align="center"><table style="margin: 20px 0 20px 0;"><tr><td align="center"> <a data-social-media="facebook" href="https://www.facebook.com/" target="_blank"><img src="https://vastreach.com/static_assets/facebook.png" border="0" style="background-color: #a09e00; padding: 4px; border-radius:28px;" /></a> </td><td align="center"> <a data-social-media="instagram" href="https://www.instagram.com/" target="_blank"><img src="https://vastreach.com/static_assets/instagram.png" border="0" style="background-color: #a09e00;padding: 4px; border-radius:28px;" /></a> </td><td align="center"> <a data-social-media="twitter" href="https://twitter.com/" target="_blank"><img src="https://vastreach.com/static_assets/twitter.png" border="0" style="background-color: #a09e00;padding: 4px; border-radius:28px;" /></a> </td></tr></table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
    Paragraph: {
      icon: 'Notes',
      text: 'Paragraph',
      editor: 'wysiwyg',
      html: `<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px;margin: 0 auto 0;padding: 10px 20px;text-align: center;background: transparent;"> <span style="font-size: medium;color:#000000;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">We have over 40 Hot Tubs & Swim Spas on Display from Major Brands and Everything Must Go! </span></div><!-- End of Dynamic WYSIWYG Content -->`,
    },
    '3 Columns (Image + Paragraph)': {
      icon: 'ViewColumn',
      text: '3 Columns (Image + Paragraph)',
      editor: 'wysiwyg',
      html: '<!-- Dynamic WYSIWYG Content --><table cellpadding="0" cellspacing="0" border="0" style="margin: 0 auto; padding: 20px 10px 20px 10px; background: transparent;"><tr><td width="600" align="center"><table cellpadding="0" cellspacing="0"><tr><td width="290" valign="top"><table cellpadding="0" cellspacing="0" style="padding: 5px;"><tr><td><img style="width: 100%; display: block; border: 0;" src="https://vastreach.com/static_assets/snippets/feat_1.jpg" alt="Featured image 1" width="290" /></td></tr><tr><td align="left"><h3 style="padding:10px 0 10px 0;height:50px;text-align:left;">Feature or Topic Here</h3></td></tr><tr><td align="left"><p style="margin:0;padding:5px;text-align:left;font-size: 16px;font-weight: 500;">You can place your feature or topic image above, and describe that feature or topic here in a few short sentences.</p></td></tr></table></td><td width="290" valign="top"><table cellpadding="0" cellspacing="0" style="padding: 5px;"><tr><td><img style="width: 100%; display: block; border: 0;" src="https://vastreach.com/static_assets/snippets/feat_2.jpg" alt="Featured image 2" width="290" /></td></tr><tr><td align="left"><h3 style="padding:10px 0 10px 0;height:50px;text-align:left;">Feature or Topic Here</h3></td></tr><tr><td align="left"><p style="margin:0;padding:5px;text-align:left;font-size: 16px;font-weight: 500;">You can place your feature or topic image above, and describe that feature or topic here in a few short sentences.</p></td></tr></table></td><td width="290" valign="top"><table cellpadding="0" cellspacing="0" style="padding: 5px;"><tr><td><img style="width: 100%; display: block; border: 0;" src="https://vastreach.com/static_assets/snippets/feat_3.jpg" alt="Featured image 3" width="290" /></td></tr><tr><td align="left"><h3 style="padding:10px 0 10px 0;height:50px;text-align:left;">Feature or Topic Here</h3></td></tr><tr><td align="left"><p style="margin:0;padding:5px;text-align:left;font-size: 16px;font-weight: 500;">You can place your feature or topic image above, and describe that feature or topic here in a few short sentences.</p></td></tr></table></td></tr></table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
    'Image Banner + Text': {
      icon: 'Satellite',
      text: 'Image Banner + Text',
      editor: 'wysiwyg',
      html: '<!-- Dynamic WYSIWYG Content --><table border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 600px; margin: 0 auto; padding: 0; text-align: center; background-color: #ffffff;"><tr><td valign="middle" style="background-image: url(https://vastreach.com/static_assets/snippets/customer_support.jpg);background-position: center center !important;background-size: cover !important;text-align: center;background-repeat: no-repeat;padding: 50px 0 50px 0;background-position: center;background-size: cover;"><table border="0" cellpadding="0" cellspacing="0" style="width: 100%;"><tr><td valign="middle" style="text-align: center; padding: 50px 50px 50px; font-size: 15px; line-height: 20px; color: #ffffff;"><h2 style="font-size: 35px; font-weight: 600; font-family: Tahoma, Geneva, sans-serif; word-wrap: break-word; line-height: 1.5; display: inline-block; vertical-align: middle;">YOUR STATEMENT <b style="color: #a09e00;">HERE</b></h2><p style="margin: 0; color: #ffffff; font-size: 14px; font-weight: 550; font-family: Arial, Helvetica, sans-serif;">Place a description or your mission statement here. We recommend using a darker image on lighter text or lighter image on darker text.</p></td></tr></table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
  },
  value: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" style="width: 100%;height: 100%;margin: 0;padding: 0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">

<head>
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
  <meta name="viewport" content="width=device-width"/>
  <meta class="vastreach-theme" data-vast-theme="newsletter"/>
</head>	

<body align="center" style="margin: 0;padding:0;background-color: #ffffff;">
  <div class="background" style="background: #ffffff;">
    <div class="foreground" style="max-width: 600px;background: #ffffff;">
		<table style="max-width: 600px;margin: 0 auto 0;padding: 0;text-align: center;border-spacing: 0;">
			<tr>
				<td width="600" align="center" class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<table style="width: 100%;max-width: 600px;margin: 0 auto;padding: 0;text-align: center;background: transparent;">
						<tr>
							<td> 				
								<table cellpadding="0" cellspacing="0" style="margin: 20px auto 20px auto;border-spacing: 0;">
									<tr>
										<td width="290" valign="center" align="left">
											<table cellpadding="0" cellspacing="0" style="border-spacing: 0;">
												<tr>
													<td>
													<img src="https://vastreach.com/static_assets/email/newsletter_1/beta-logo.png" alt="logo" style="max-width: 100%;margin: 0 auto;display: block;" />
													</td>
												</tr>
											</table>
										</td>
										<td width="290" valign="center" align="right">
											<table cellpadding="0" cellspacing="0" style="border-spacing: 0;">
												<tr>
													<td>
													<a href="#" target="_blank"><h2 style="margin-right: 10px; font-size: 12px; color: #000000;">BLOG</h2></a>
													</td>
												</tr>
											</table>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</table> 							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>
			</tr>
			
			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;text-align: center;margin:0 auto;padding: 30px 10px; background-color: #000000;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
						<p><span style="color:#ffffff; padding: 0; margin:0; line-height: 1.65; font-family: Arial, Helvetica, sans-serif; font-size: x-large;">Subscribe to our promotional emails with a touch of a button!</span></p>
					</div>						
					<!-- End of Dynamic WYSIWYG Content -->
				</td>	
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="button" style="padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px; margin: 0 auto; padding: 0; text-align: center; background: transparent;max-width: 600px;margin: 0 auto 0;padding: 10px 0;text-align: center;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
						<p style="text-align: center;margin:0;">
							<a data-button-text="Start now" data-button-url="https://www.vastreach.com" data-button-color="#ffffff" data-button-background-color="#a09e00" href="#" target="_blank">
								<button style="color: #ffffff; background-color: #a09e00;border: 0; padding: 15px 25px; margin: 0; border-radius: 0; cursor: pointer;"><strong>Start Now</strong></button>
							</a>
						</p>
					</div>								
					<!-- End of Dynamic WYSIWYG Content -->
				</td>	
			</tr>		

			<tr>	
				<td class="vastreach-sections" data-vast-editor="img-picker" style="padding: 0;">
				<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">			  
						<img src="https://vastreach.com/static_assets/email/newsletter_1/pool.jpg" alt="pool" style="max-width: 100%;margin: 0 auto;padding: 0;display: block;">
					</div> 							  
					<!-- End of Dynamic WYSIWYG Content -->
				</td>  
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto 0;padding: 10px 20px;text-align: center;background: transparent;">        
						<span style="font-size: medium;color:#000000;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Provide a brief summary of the blog contents to engage customers to open it.</span>
					</div>
					<!-- End of Dynamic WYSIWYG Content -->			
				</td>	
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="button" style="padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto 0;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
						<p style="text-align: center;margin:0;">
							<a data-button-text="Start now" data-button-url="https://www.vastreach.com" data-button-color="#ffffff" data-button-background-color="#a09e00" href="#" target="_blank">
								<button style="color: #ffffff; background-color: #a09e00;border: 0; padding: 15px 25px; margin: 0; border-radius: 0; cursor: pointer;"><strong>Start Now</strong></button>
							</a>
						</p>
					</div>		
					<!-- End of Dynamic WYSIWYG Content -->			
				</td>	
			</tr>
			
			<tr>
				<td valign="top" class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<table style="width: 100%;max-width: 600px;margin: 0 auto;padding: 20px;text-align: center;background: transparent;">
						<tr>
							<td> 				
								<table cellspacing="0" cellpadding="0" border="0" style="padding: 0 10px 0 10px;border-spacing: 0;">
									<tbody>
										<tr>
											<td style="padding: 0 10px 0 10px;" valign="top">
												<table width="100%" cellspacing="0" cellpadding="0" border="0" style="border-spacing: 0;">
													<tbody>
														<tr>
															<td width="33.33%" valign="top">
																<table style="width:100%;padding:5px;border-spacing: 0;" cellspacing="0" cellpadding="0" border="0">
																	<tbody>
																		<tr>
																			<td>
																				<img src="https://vastreach.com/static_assets/email/newsletter_1/feat_1.jpg" alt="Featured image 1" style="max-width: 100%;margin: 0 auto;display: block;" />
																			</td>
																		</tr>
																		<tr>
																			<td>
																				<h2 style="padding:10px 0 10px 0;height:50px;text-align:left;">Feature or Topic Here</h2>
																				<p style="margin:0;padding:5px;text-align:left;font-size: 16px;font-weight: 500;">You can place your feature or topic image above, and describe that feature or topic here in a few short sentences.</p>
																				<!--<p><a href="#" target="_blank"><button style="margin-top:20px;color: #ffffff;background-color: #a09e00;border: 0;padding: 15px 25px; cursor: pointer;"><strong>Read More</strong></button></a></p>-->
																			</td>
																		</tr>
																	</tbody>
																</table>
															</td>
															<td width="33.33%" valign="top">
																<table style="width:100%;padding:5px;border-spacing: 0;" cellspacing="0" cellpadding="0" border="0">
																	<tbody>
																		<tr>
																			<td>
																				<img src="https://vastreach.com/static_assets/email/newsletter_1/feat_2.jpg" alt="Featured image 2" style="max-width: 100%;margin: 0 auto;display: block;" />
																			</td>
																		</tr>
																		<tr>
																			<td>
																				<h2 style="padding:10px 0 10px 0;height:50px;text-align:left;">Feature or Topic Here</h2>
																				<p style="margin:0;padding:5px;text-align:left;font-size: 16px;font-weight: 500;">You can place your feature or topic image above, and describe that feature or topic here in a few short sentences.</p>
																				<!--<p><a href="#" target="_blank"><button style="margin-top:20px;color: #ffffff;background-color: #a09e00;border: 0;padding: 15px 25px; cursor: pointer;"><strong>Read More</strong></button></a></p>-->
																			</td>
																		</tr>
																	</tbody>
																</table>
															</td>
															<td width="33.33%" valign="top">
																<table style="width:100%;padding:5px;border-spacing: 0;" cellspacing="0" cellpadding="0" border="0">
																	<tbody>
																		<tr>
																			<td><img src="https://vastreach.com/static_assets/email/newsletter_1/feat_3.jpg" alt="Featured image 3" style="max-width: 100%;margin: 0 auto;display: block;" /></td>
																		</tr>
																		<tr>
																			<td>
																				<h2 style="padding:10px 0 10px 0;height:50px;text-align:left;">Feature or Topic Here</h2>
																				<p style="margin:0;padding:5px;text-align:left;font-size: 16px;font-weight: 500;">You can place your feature or topic image above, and describe that feature or topic here in a few short sentences.</p>
																				<!--<p><a href="#" target="_blank"><button style="margin-top:20px;color: #ffffff;background-color: #a09e00;border: 0;padding: 15px 25px; cursor: pointer;"><strong>Read More</strong></button></a></p>-->
																			</td>
																		</tr>
																	</tbody>
																</table>
															</td>
														</tr>
													</tbody>
												</table>
											</td>
										</tr>
									</tbody>
								</table>
							</td>
						</tr>
					</table> 							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;text-align: center;margin:0 auto;padding: 30px 10px; background-color: #000000;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
						<p><span style="color:#ffffff; padding: 0; margin:0; line-height: 1.65; font-family: Arial, Helvetica, sans-serif; font-size: x-large;">View previous newsletters in our Archives.</span></p>
					</div>							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>	
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="button" style="padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto 0;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
						<p style="text-align: center;margin:0;">
							<a data-button-text="Start now" data-button-url="https://www.vastreach.com" data-button-color="#ffffff" data-button-background-color="#a09e00" href="#" target="_blank">
								<button style="color: #ffffff; background-color: #a09e00;border: 0; padding: 15px 25px; margin: 0; border-radius: 0; cursor: pointer;"><strong>Start Now</strong></button>
							</a>
						</p>
					</div>					
					<!-- End of Dynamic WYSIWYG Content -->
				</td>	
			</tr>			        				
		</table> 
	</div>					
</div>					
</body>	
</html>`,
}
